import { Injectable } from '@angular/core';

import { BaseBetslipGroupPick } from '../../../../../../core/picks/betslip-group-pick';
import { BetslipPick } from '../../../../../../core/picks/betslip-pick';
import { GroupWithUncombinableLegsPreCheckError } from '../../../../errors/general/group-pick-error';
import { IPureLinearPickValidator } from '../validators';

@Injectable()
export class GroupPickWithUncombinableLegsValidator implements IPureLinearPickValidator<GroupWithUncombinableLegsPreCheckError> {
    validate(pick: BetslipPick): GroupWithUncombinableLegsPreCheckError[] {
        const hasPickUncombinableLegs = BaseBetslipGroupPick.isPick(pick) && pick.groupHasUncombinableLeg();

        return hasPickUncombinableLegs ? [new GroupWithUncombinableLegsPreCheckError(pick.id.toString())] : [];
    }
}
